import React from "react";
import { AddRoadOutlined, HolidayVillageOutlined, PictureInPictureOutlined } from "@mui/icons-material";
import { Feature, Geometry } from "geojson";

import { lineStringDrawingConfig, pointDrawingConfig, polygonDrawingConfig, ToolbarConfig } from "fond/map/Toolbar";
import { MuPowerInputLayerId, MuPowerInputLayerIds } from "fond/types";
import { isAnyLineString, isAnyPoint, isAnyPolygon } from "fond/types/geojson";
import { SvgIcon } from "fond/widgets";

export interface MuPowerInputLayerConfig {
  key: MuPowerInputLayerId;
  title: string;
  displayName: string;
  navigationKey: string;
  icon: React.ReactElement;
  geometryType: "Point" | "LineString" | "Polygon";
  group: "Base data";
  isRequired?: boolean;
  drawingConfig: ToolbarConfig;
  filterFeatures: (feature: Feature<Geometry>) => boolean;
  combineToMultiPolygon?: boolean;
}

export const muPowerInputLayers: MuPowerInputLayerConfig[] = [
  {
    key: MuPowerInputLayerIds.boundary,
    title: "Boundary",
    displayName: "Boundary",
    navigationKey: "mu-boundary",
    icon: <SvgIcon icon="polygon" />,
    geometryType: "Polygon",
    group: "Base data",
    isRequired: false,
    drawingConfig: polygonDrawingConfig,
    filterFeatures: isAnyPolygon,
    combineToMultiPolygon: true,
  },
  {
    key: MuPowerInputLayerIds.addresses,
    title: "Addresses",
    displayName: "Addresses",
    navigationKey: "mu-address",
    icon: <HolidayVillageOutlined />,
    geometryType: "Point",
    group: "Base data",
    isRequired: true,
    drawingConfig: pointDrawingConfig,
    filterFeatures: isAnyPoint,
  },
  {
    key: MuPowerInputLayerIds.parcels,
    title: "Parcels",
    displayName: "Parcels",
    navigationKey: "mu-parcel",
    icon: <PictureInPictureOutlined />,
    geometryType: "Polygon",
    group: "Base data",
    isRequired: true,
    drawingConfig: polygonDrawingConfig,
    filterFeatures: isAnyPolygon,
  },
  {
    key: MuPowerInputLayerIds.streets,
    title: "Streets",
    displayName: "Streets",
    navigationKey: "mu-street",
    icon: <AddRoadOutlined />,
    geometryType: "LineString",
    group: "Base data",
    isRequired: true,
    drawingConfig: lineStringDrawingConfig,
    filterFeatures: isAnyLineString,
  },
  {
    key: MuPowerInputLayerIds.poles,
    title: "Poles",
    displayName: "Poles",
    navigationKey: "mu-pole",
    icon: <SvgIcon icon="points" />,
    geometryType: "Point",
    group: "Base data",
    isRequired: false,
    drawingConfig: pointDrawingConfig,
    filterFeatures: isAnyPoint,
  },
];
